/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-citta-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function toISODate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }
    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function formatIntIt(v) {
        var n = Number(v);
        if (!isFinite(n)) return '—';
        return Math.round(n).toLocaleString('it-IT', { maximumFractionDigits: 0 });
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        ['city_slug', 'metric', 'min_participations', 'date_from', 'date_to'].forEach(function (k) {
            var v = fd.get(k);
            if (v != null && String(v).trim() !== '') out[k] = String(v).trim();
        });
        return out;
    }

    function initCityAutocomplete() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var input = form.querySelector('input[name="city_query"]');
        var hidden = form.querySelector('input[name="city_slug"]');
        var list = document.getElementById('radar-citta-city-list');
        if (!input || !hidden || !list) return;

        function slugifyCity(s) {
            var t = String(s || '').trim().toLowerCase();
            t = t.replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
            return t.slice(0, 160);
        }

        function render(items) {
            while (list.firstChild) list.removeChild(list.firstChild);
            lastMap = {};
            (items || []).forEach(function (it) {
                var opt = document.createElement('option');
                opt.value = it.label || it.city_norm || '';
                list.appendChild(opt);
                if (opt.value && it.slug) lastMap[String(opt.value).toLowerCase()] = String(it.slug);
            });
        }

        var pending;
        var lastFetch = 0;
        var lastMap = {};
        function fetchSuggest(q) {
            var now = Date.now();
            lastFetch = now;
            var url = apiBase + '/radar/hub/city-suggest?q=' + encodeURIComponent(q) + '&limit=20';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) {
                    if (lastFetch !== now) return;
                    render((data && data.items) || []);
                })
                .catch(function () {});
        }

        input.addEventListener('input', function () {
            var q = String(input.value || '').trim();
            if (pending) window.clearTimeout(pending);
            if (q.length < 2) return;
            pending = window.setTimeout(function () { fetchSuggest(q); }, 180);
        });

        function syncHidden() {
            var raw = String(input.value || '').trim();
            if (!raw) return;
            var key = raw.toLowerCase();
            hidden.value = lastMap[key] || slugifyCity(raw);
        }
        input.addEventListener('input', syncHidden);
        input.addEventListener('blur', syncHidden);
    }

    function guessCityFromPath() {
        try {
            var parts = window.location.pathname.split('/').filter(Boolean);
            var i = parts.indexOf('citta');
            if (i >= 0 && parts[i + 1]) return String(parts[i + 1]).toLowerCase();
        } catch (e) {}
        return '';
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    var table;
    function buildTable() {
        if (typeof Tabulator === 'undefined') { setStatus('Tabulator non disponibile.'); return; }
        var el = qs('#radar-citta-table', root);
        if (!el || table) return;

        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Nessun dato',
            pagination: true,
            paginationMode: 'remote',
            paginationSize: 25,
            paginationSizeSelector: [25, 50, 100],
            ajaxURL: apiBase + '/radar/city/_/rankings',
            ajaxParams: function () { return readFilters(); },
            ajaxConfig: function () {
                var token = client.tokenStore.getToken() || '';
                return { method: 'GET', headers: { Accept: 'application/json', Authorization: token ? 'Bearer ' + token : '' } };
            },
            ajaxURLGenerator: function () {
                var f = readFilters();
                var slug = String(f.city_slug || '_').toLowerCase().replace(/[^a-z0-9\-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || '_';
                return apiBase + '/radar/city/' + encodeURIComponent(slug) + '/rankings';
            },
            ajaxResponse: function (url, params, resp) {
                var perPage = resp.per_page || params.size || 25;
                var total = resp.total || 0;
                var lastPage = Math.max(1, Math.ceil(total / perPage) || 1);
                return { last_page: lastPage, data: resp.items || [] };
            },
            columns: [
                { title: 'Azienda', field: 'canonical_name', minWidth: 200, formatter: function (c) { return '<span>' + escHtml(c.getValue() || '—') + '</span>'; } },
                { title: 'Dim.', field: 'company_size', width: 70 },
                { title: 'Part.', field: 'participations_total', width: 90, hozAlign: 'right', formatter: function (c) { return formatIntIt(c.getValue()); } },
                { title: 'Vitt.', field: 'wins_total', width: 80, hozAlign: 'right', formatter: function (c) { return formatIntIt(c.getValue()); } },
                { title: 'Imp. agg. €', field: 'awarded_amount_eur_sum', width: 130, hozAlign: 'right', formatter: function (c) { return formatEuroIt(c.getValue()); } }
            ]
        });
        root._vgTabulator = table;
    }

    function applyDefaults() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var cityHidden = qs('input[name="city_slug"]', form);
        var cityQuery = qs('input[name="city_query"]', form);
        var guessed = guessCityFromPath();
        if (guessed && cityHidden && !String(cityHidden.value || '').trim()) cityHidden.value = guessed;
        if (guessed && cityQuery && !String(cityQuery.value || '').trim()) cityQuery.value = guessed.replace(/-/g, ' ');

        var from = qs('input[name="date_from"]', form);
        var to = qs('input[name="date_to"]', form);
        if (from && to && !String(from.value || '').trim() && !String(to.value || '').trim()) {
            var now = new Date();
            var jan1 = new Date(now.getFullYear(), 0, 1);
            from.value = toISODate(jan1);
            to.value = toISODate(now);
        }
    }

    function refresh() {
        if (!table) return;
        setStatus('Caricamento…');
        table.setData().then(function () { setStatus(''); }).catch(function () { setStatus('Impossibile caricare.'); });
    }

    buildTable();
    applyDefaults();
    initCityAutocomplete();
    refresh();

    var form = qs('[data-radar-filters]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); refresh(); });
})(window, document);

